import {
  SupportService as AdminSupportService,
  TicketCategoryEnum,
  TicketStatusEnum,
} from '@acme/api/admin';
import type { TicketResponse } from '@acme/domains';
import {
  createTicketsListModel,
  getTicketsApiParams,
} from '@acme/features';

function getSearchHaystack(ticket: TicketResponse): string {
  return [
    ticket.number != null ? String(ticket.number) : '',
    ticket.applicationCode ?? '',
    ticket.subject ?? '',
    ticket.categoryId?.name ?? '',
    ticket.status?.name ?? '',
    'organizationName' in ticket ? (ticket.organizationName ?? '') : '',
    'userName' in ticket ? (ticket.userName ?? '') : '',
  ].join(' ');
}

export const ticketsListModel = createTicketsListModel<TicketResponse>({
  defaultPageSize: 20,
  getApiParams: getTicketsApiParams,
  getSearchHaystack,
  fetch: async ({
    statusId,
    categoryId,
    dateFrom,
    dateTo,
    pageNumber,
    pageSize,
  }) => {
    const res = await AdminSupportService.getApiAdminV1SupportTicketList({
      statusId: statusId as TicketStatusEnum | undefined,
      categoryId: categoryId as TicketCategoryEnum | undefined,
      dateFrom,
      dateTo,
      pageNumber,
      pageSize,
    });
    if (!res.isSuccess || !res.data) {
      throw new Error(res.errorText || 'Не удалось загрузить заявки');
    }
    return {
      items: res.data.items ?? [],
      totalCount: res.data.totalCount ?? 0,
    };
  },
});
